import { appGetState } from 'legacy/lut/store'
import { lookupGetStateOld } from 'legacy/lut/store'
import { FC, useEffect, useState } from 'react'

import { Operator } from 'core-components/types'

import { isIFilter } from '../../helpers/isIFilter'

import { ICountriesOfBusinessFiltersProps } from './models'

export const CountriesOfBusinessFilters: FC<ICountriesOfBusinessFiltersProps> = ({ filter }) => {
  const [field, setField] = useState('')
  const [operator, setOperator] = useState<string>(Operator.CONTAINS)

  const countries = lookupGetStateOld().references.countries
  const countriesName = filter.filters.map((el) =>
    countries.find((country) => isIFilter(el) && country.value === el.value)
  )

  useEffect(() => {
    if (isIFilter(filter.filters[0])) {
      setField(filter.filters[0].field)
      setOperator(filter.filters[0].operator)
    }
  }, [filter.filters])

  return (
    <span>
      {field} {operator === Operator.CONTAINS ? 'eq' : operator}{' '}
      {countriesName.map(
        (el: any, index: number) => el.name + (index !== countriesName.length - 1 ? ', ' : '')
      )}
    </span>
  )
}
